import React, {useMemo} from "react";
import { withStyles } from "@mui/styles";

const styles = {
  datetime:{
    display:'flex',
    alignItems: 'baseline',
    fontSize:'0.8rem',
    gap: '0.35em',
    '& > div':{
      whiteSpace: 'nowrap',
    },
  },
  cellSubtext:{
    fontSize:'0.85em',
    fontWeight:'300',
    lineHeight: '1em'
  },
  cellSubtextLg:{
    fontSize:'0.8rem',
  },
}

function DateDisplay(props) {
  const { date:dateString, direction="row", timeSize="small", classes, ...divProps } = props;

  const date = useMemo(() => !dateString ? undefined : new Date(dateString), [dateString]);
  const timeString = useMemo(() => date?.toLocaleTimeString?.() || '', [date]);

  return(
    <div className={classes.datetime} {...divProps} style={{...divProps.style, flexDirection: direction}}>
      <div>{date?.toLocaleDateString?.() || ''}</div>
      {!timeString ? null : <div className={timeSize === "large" ? classes.cellSubtextLg : classes.cellSubtext}>{timeString}</div>}
    </div>
  )
}

export default withStyles(styles)(DateDisplay)